import React from 'react';
import { Button } from '@progress/kendo-react-buttons'

class DadosEntidade extends React.Component{
    constructor(props){
        super(props);
        this.state={
           
        }
    }
    componentDidMount(){
        
    }
    

    estatutosRender=()=>{
        return (this.props.estatutosRes.map((key,index)=>{
            return (<>
                <span className="border p-1 mr-3 mb-2 text-center" style={{minWidth:"25%"}} key={index}>{key}</span>
            </>)
        }))
    }

    render(){
        let {estatutosRes} = this.props;
        const row = this.props.row
        const entityDetail = this.props.entityDetail
        const dadosDetail = this.props.dadosDetail

        return(<>
        <div className="mt-3">
            <div style={{marginRight:"30%"}} className="my-3 ml-3 d-flex k-justify-content-between">
                <div>
                    <p className="k-mb-0"><strong>nº entidade</strong></p>
                    <p className="k-mt-0">{row['idEntidadeAplicacao']}</p>
                </div>
                <div style={{marginRight:"125px"}}> 
                    <Button primary={true}>Ficha de Entidade</Button>
                </div>
            </div>
            <div className="my-4 ml-3">
                <p className="k-mb-0"><strong>Entidade</strong></p>
                <p className="k-mt-0">{row['Entidade']}</p>
            </div>
            <div style={{marginRight:"30%"}} className="my-3  ml-3 d-flex k-justify-content-between">
                <div>
                    <p className="k-mb-0"><strong>Telefone</strong></p>
                    <p className="k-mt-0">{entityDetail['telephone'] || "ND"}</p>
                </div>
                <div>
                    <p className="k-mb-0"><strong>Fax</strong></p>
                    <p className="k-mt-0">{entityDetail['fax'] || "ND"}</p>
                </div>
                <div>
                    <p className="k-mb-0"><strong>Email</strong></p>
                    <p className="k-mt-0">{entityDetail['email'] || "ND"}</p>
                </div>
            </div>
            <div className="my-4 ml-3">
                <p className="k-mb-0"><strong>Observações</strong></p>
                <p className="k-mt-0">{row['observacao']}</p>
            </div>
            <div className="my-4 ml-3">
                <p className="k-mb-0"><strong>Estatutos</strong></p>
                { estatutosRes &&
                    <div className="d-flex w-25 flex-wrap">
                        {
                            this.estatutosRender()
                        }
                    </div>
                }
            </div>

            <div className="col-md-12 my-4">
                <p className="k-mb-0"><strong>Saldo - Selos impressos</strong></p>
                <table className="w-100 text-center">
                    <thead className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25"><strong>Tipo</strong></td>
                            <td className="w-25"><strong>disponiveis</strong></td>
                            <td className="w-25"><strong>aplicados</strong></td>
                            <td className="w-25"><strong>Inutilizados</strong></td>
                            <td className="w-25"><strong>Previsão Semestral</strong></td>
                        </tr>
                    </thead>
                    <tbody className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25">{row['tipoSelo']}</td>
                            <td className="w-25">{dadosDetail["numeroSelo"]}</td>
                            <td className="w-25">{dadosDetail["aplicados"]}</td>
                            <td className="w-25">{dadosDetail["inutilizados"]}</td>
                            <td className="w-25">{dadosDetail["semestral"]}</td>
                        </tr>
                    </tbody>
                </table>
             </div>

            <div className="col-md-12 my-4">
                <p className="k-mb-0"><strong>Saldo - Séries de selos</strong></p>
                <table className="w-100 text-center">
                    <thead className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25"><strong>nº série</strong></td>
                            <td className="w-25"><strong>disponiveis</strong></td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                        </tr>
                    </thead>
                    <tbody className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25">{row['serie']}</td>
                            <td className="w-25">{dadosDetail["numeroSelo"]}</td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                        </tr>
                    </tbody>
                </table>
             </div>

             <div className="col-md-12 my-4">
                <p className="k-mb-0"><strong>Pedidos semelhantes</strong></p>
                <table className="w-100 text-center">
                    <thead className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25"><strong>Data</strong></td>
                            <td className="w-25"><strong>Tipo de pedido</strong></td>
                            <td className="w-25"><strong>Estado</strong></td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                        </tr>
                    </thead>
                    <tbody className="border">
                        <tr className="d-flex justify-content-around py-2">
                            <td className="w-25">{row['Data de Pedido']}</td>
                            <td className="w-25">{row['tipoPedido']}</td>
                            <td className="w-25">{row['estado']}</td>
                            <td className="w-25">{""}</td>
                            <td className="w-25">{""}</td>
                        </tr>
                    </tbody>
                </table>
             </div>

        </div>
        </>)
    }
}

export default DadosEntidade;